import { useMutation, useQuery } from "@tanstack/react-query";
import { fetch3, fetch5, fetch8 } from "../commonApis/commonApis";
import { useDispatch } from "react-redux";

import {
  addProduct,
  productUpdate,
  setProductList,
} from "../features/auth/product/productSlice";
const url = process.env.REACT_APP_BASE_URL;

interface ApiResponse {
  success: boolean;
  data: any;
  message?: string;
}

// Create Product API

export const useItemProductCreateMutation = () => {
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch8(
        `${url}/api/product-item?type=lmClient`,
        // `${url}/api/product-item/`,
        "POST",
        payload
      );

      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ time-slots Created successfully:", data);
      dispatch(addProduct(data));
    },
    onError: (error: any) => {
      console.error("❌ time-slots create request failed:", error.message);
    },
  });
};

export const useItemsUpdateMutation = (id: string) => {
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch8(
        `${url}/api/product-item/${id}?type=lmClient`,
        "PUT",
        payload
      );

      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      dispatch(productUpdate(res.data));
      return res.data;
    },
  });
};

// List Fatch Data
export const useFetchProductItemData = (
  page: number,
  limit: number,
  searchFor: string
) => {
  const dispatch = useDispatch();
  return useQuery({
    queryKey: ["itemCategoriesData", page, limit, searchFor],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/product-item?page=${page}&limit=${limit}&searchFor=${encodeURIComponent(searchFor)}&type=lmClient`,
        "get"
      );

      if (!res || !res.data) {
        return res.message;
      }
      dispatch(setProductList(res.data));
      return res.data;
    },
    staleTime: 1000 * 60 * 5,
  });
};

// Status Update
interface UpdateItemProductStatusPayload {
  id: string;
  status: any;
}

export const useUpdateProductItemStatus = () => {
  return useMutation({
    mutationFn: async ({ id, status }: UpdateItemProductStatusPayload) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/product-item/${id}/status?type=lmClient`,
        "PATCH",
        {
          status,
        }
      );

      if (!res.success) {
        throw new Error(res.message || "Failed to update vehicle status");
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Items status updated successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Items status update failed:", error.message);
    },
  });
};

export const useProductCategoryAllListData = () => {
  return useQuery({
    queryKey: ["allListCategories"],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/item-category/all-categories?type=lmClient`,
        "get"
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data;
    },
    staleTime: 0,
  });
};

export const useProductSubCategoriesListData = (category: string) => {
  return useQuery({
    queryKey: ["itemSubCategoriesData", category],
    queryFn: async () => {
      if (!category) return [];
      const res = await fetch3(
        `${url}/api/item-category/sub-categories?category=${encodeURIComponent(category)}&type=lmClient`,
        "get"
      );
      if (!res || !res.data) {
        return [];
      }
      return res.data;
    },
    enabled: !!category,
    staleTime: 0,
  });
};

export const useFetchProductItemsViewData = (id?: string) => {
  return useQuery({
    queryKey: ["productItemsViewData", id],
    queryFn: async () => {
      if (!id) return null;
      const res = await fetch3(
        `${url}/api/product-item/${id}?type=lmClient`,
        "get"
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data;
    },
    enabled: !!id,
    staleTime: 1000 * 60 * 5,
  });
};
